export const LAYOUT_X_PADDING = 'px-6 sm:px-16';
